export default {
  methods: {
    async fetchSlides (pageStart, pageSize) {
      const slides = []
      let page = pageStart
      while (true) {
        const {
          results: newSlides,
          next
        } = await this.$serverBackend.get(
          `/diagrams/${this.diagram.id}/images/`,
          {
            page,
            page_size: pageSize,
            ordering: 'order'
          }
        )
        slides.push(...newSlides)
        page++
        if (!next) {
          break
        }
      }
      return slides
    }
  }
}
